import React from 'react';
import BrandingAppTitle from '../components/common/BrandingAppTitle';
import { appVersion } from '../config';

export default function Footer() {
  return (
    <footer className="mboss-footer" role="contentinfo">
      <div className="mboss-footer__inner">
        <p className="mboss-footer__meta mb-0">
          © {new Date().getFullYear()} <BrandingAppTitle />
          {appVersion ? <span className="mboss-footer__version"> · v{appVersion}</span> : null}
        </p>
      </div>
    </footer>
  );
}
